import { Map, fromJS } from 'immutable';
import { STATUS, EMPTY_STRING, SVC_TYPE } from '@constants/common';
import { NOTIFICATION_UPDATE, RESET_CRUD_NOTIFICATION } from '@constants/actions';
import { IServiceNotification, IActionNotification } from '@interfaces/common.interface';

const emptyActionNotification: IActionNotification = {
  status: EMPTY_STRING,
  message: EMPTY_STRING,
  isSuccess: false,
};

const emptyNotificationState: IServiceNotification = {
  ADD: emptyActionNotification,
  GET: emptyActionNotification,
  UPDATE: emptyActionNotification,
  DELETE: emptyActionNotification,
  LIST: emptyActionNotification,
  RETRIEVE: emptyActionNotification,
};

const generateNotificationInitialState = () => {
  const initialState = {};
  Object.values(SVC_TYPE).forEach(type => {
    initialState[type] = emptyNotificationState;
  });
  return fromJS(initialState);
};

const initialState = generateNotificationInitialState();

const Notification = (state = initialState, action: any) => {
  const payload = action.payload || null;
  switch(action.type) {
    case NOTIFICATION_UPDATE:
      return state.setIn([payload.serviceType, payload.operationType], fromJS({ ...payload.notification }));
    case RESET_CRUD_NOTIFICATION:
      if (payload.serviceType && payload.operationType) {
        return state.setIn([payload.serviceType, payload.operationType], fromJS(emptyActionNotification));
      } 
      return state.setIn([payload.serviceType], fromJS(emptyNotificationState));
            
    default:
      return state;
  }
};

export default Notification;